import { render, staticRenderFns } from "./PremiumSummary.vue?vue&type=template&id=a0f31954&"
import script from "./PremiumSummary.vue?vue&type=script&lang=js&"
export * from "./PremiumSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports